import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import React, { useEffect } from 'react';
import Lenis from '@studio-freight/lenis';
import AOS from 'aos';

// importing utils
import ScrollToTop from "utils/common/ScrollToTop";

// Importing Pages
import NotFound from "./pages/errors/NotFound";
import Landing from "./pages/Landing";
import About from "./pages/about/About";
import Projects from "./pages/projects/Projects";
import ProjectDetail from "./pages/projects/ProjectDetail";
import Contact from "./pages/contact/Contact";
//import Photography from "pages/photography/Photography";
import Alisha from "pages/Alisha";
import AlbumDisplay from "pages/photography/AlbumDisplay";
import OrchardDesign from "pages/orcharddesign/OrchardDesign";

export const lenis = { current: null }; // simple object to hold Lenis instance

function App() {
  AOS.init();

  useEffect(() => {
    // Initialize Lenis
    lenis.current = new Lenis({
      duration: 1.4, // Control the duration of the scroll
      easing: (t) => 1 - Math.pow(1 - t, 5), // Cubic easing for smooth stop
      smooth: true,
      smoothTouch: true, // Enable smooth scrolling on touch devices
    });

    const animate = (time) => {
      lenis.current.raf(time);
      requestAnimationFrame(animate);
    };

    requestAnimationFrame(animate);

    // Cleanup on unmount
    return () => {
      lenis.current.destroy();
    };
  }, []);

  return (
    <Router>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/cover-letter-orcharddesign" element={<OrchardDesign />} />
        <Route path="/alisha" element={<Alisha />} />
        {/* <Route path="/photography" element={<Photography />} /> */}
        <Route path="/photography/:albumName" element={<AlbumDisplay />} />
        <Route path="/projects/:projectCode" element={<ProjectDetail />} />

        {/* Errors */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
